import * as ng from '@angular/core';
import {Component, EventEmitter} from '@angular/core';
import {Magazine} from "../../../lib/entity/magazine";
import {Live} from "../../../lib/entity/live";
import {environment} from "../../../env/environment";

@Component({
  selector: 'maglive-view-error-dialog',
  templateUrl: './view-error-dialog.component.html',
  styleUrls: ['./view-error-dialog.component.scss']
})
export class ViewErrorDialogComponent {

  loginCallbackURL = environment.baseURL.mag2mypage + 'Welcome.do?ref=' + window.location.href;

  @ng.Input()
  reason: "NOT_LOGIN" | "NOT_SUBSCRIBER" | "NOT_LOGIN_SNEAK_PEEK" | "NOT_SUBSCRIBER_SNEAK_PEEK" | "FINISHED_LIVE" | "NOT_TICKET";

  @ng.Input()
  private magazine: Magazine | string;

  @ng.Input()
  private ticketEventId: Number | undefined;

  @ng.Input()
  following: Boolean;

  @ng.Output()
  follow: EventEmitter<Boolean> = new EventEmitter();

  get _magazine(): Magazine {
    if (typeof this.magazine === 'string') {
      return null;
    }
    return this.magazine;
  }

  onFollowClick(following) {
    this.follow.emit(following)
    return false
  }

  onTicketPurchaseClick() {
    const url = environment.baseURL.magticketWeb + `customer/event/${this.ticketEventId}/`;
    window.open(url);
    return false;
  }
}
